/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'

/**
 * Typescript enum
 */

export enum PlayKind {
  observe = 'observe',
  play = 'play'
}

/**
 * PlayKind
 *
 * The specific kind of different play kinds
 */
export const PlayKindEnumType = types.enumeration('PlayKind', ['observe', 'play'])
